import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import Portal from '../../atoms/Portal';

const MessageModal = ({
  icon = null,
  title = '',
  message = '',
  callback = () => {
  },
  color = '#fff',
  render = () => {
  },
  fontWeight = '300',
  marginH4 = 0,
  marginP = '15px 0',
}) => {
  const styless = {
    cancelBtnWrapper: {
      position: 'absolute',
      right: 15,
      top: 15,
      bottom: 0,
    },
    cancelIcon: {
      color: '#fff',
      fontSize: 30,
    },
  };
  return (
    <Portal>
      <div className='modal'>
        <div className='modal-overlay'></div>

        <div className='modal-body' style={{ backgroundColor: color }}>
          <div className='forgot_form'>
            {!!icon && (
              <img
                style={{ height: 90 }}
                src={require(`../../../Assets/Images/Icons/${icon}`)}
                alt=''
              />
            )}
            <div className='modal-header'>
              <h4 style={{ fontWeight: 500, marginTop: marginH4 }}>{title}</h4>
              <View style={styless.cancelBtnWrapper}>
                <TouchableOpacity
                  style={styless.cancelButton}
                  onPress={callback}
                >
                  <i>
                    <img
                      src={require('../../../Assets/Images/Icons/close_icon.png')}
                      alt='close'
                    />
                  </i>
                </TouchableOpacity>
              </View>
            </div>

            <div className='form-fields'>
              <p style={{ fontWeight, color: '#333', margin: marginP }}>
                {message}
              </p>
            </div>
            {render()}
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default MessageModal;
